import React, { Suspense, useEffect, useState } from "react";
import {
  Chart,
  CommonPorblems,
  HeroSection,
  Homelessness,
  Loader,
  Cards,
} from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomepageData, resetHomepageData } from "./store/actions";
import { setData } from "../../utils/storage";
import { Helmet } from "react-helmet";
import FontResizeWidget from "../../components/FontResizeWidget";
import { ACCESSIBILITY_FEATURE_ENABLED } from "../../config";
import { Link } from "react-router-dom";
import { parseHelmetTags } from "../../utils/utility";

const Homepage = () => {
  const dispatch = useDispatch();

  const homepageData = useSelector((state) => state.home);

  const [dropdownOption, setDropdDownOption] = useState([]);
  const [commonCards, setCommonCards] = useState();
  const [homelessCards, setHomelessCards] = useState([]);
  const [helmetTag, setHelmetTag] = useState("");
  const [topicsData, setTopicData] = useState([]);

  const [titleTag, setTitleTag] = useState();
  const [metaTags, setMetaTags] = useState();
  const [heroSection, setHeroSection] = useState();
  const [commonProblems, setCommonProblems] = useState(null);
  const [homelessness, setHomelessness] = useState();
  const [generalInformation, setGeneralInformation] = useState();
  const [personalInformation, setPersonalInformation] = useState();
  const [howItWorkSection, setHowItWorkSection] = useState();

  useEffect(() => {
    if (homepageData.isSuccess && homepageData.data !== null) {
      console.log("processed data:-", homepageData.data.success.data);
      processData(homepageData.data.success.data);
      dispatch(fetchHomepageData());
    } else {
      dispatch(fetchHomepageData());
    }
  }, []);

  useEffect(() => {
    if (homepageData.isSuccess && homepageData.data !== null) {
      processData(homepageData.data.success.data);

      dispatch(resetHomepageData());
    } else if (homepageData.isError) {
      dispatch(resetHomepageData());
    }
  }, [homepageData]);

  useEffect(() => {
    if (helmetTag !== "") {
      // console.log("helmetTag:-", helmetTag);
      const { titleTag, metaTags } = parseHelmetTags(helmetTag);
      setTitleTag(titleTag);
      setMetaTags(metaTags);
    }
  }, [helmetTag]);

  const processData = (data) => {
    let rentingType = data.rentingTypes;
    let commonCardsList = data.commonProblems;
    let homelessCardsList = data.homelessnessExternalSites;
    for (let rentingData in rentingType) {
      let obj = {
        id: rentingData,
        value: rentingType[rentingData],
      };
      const objLen = dropdownOption.filter((item) => item.id === obj.id);

      if (!objLen.length > 0) {
        setDropdDownOption((current) => [...current, obj]);
      }
    }
    setHelmetTag(data.homeMetaData);
    console.log("commonCardsList:-", commonCardsList);
    setCommonCards(commonCardsList);
    setHomelessCards(homelessCardsList);
    setTopicData(data.topics);
    setData("homepageData", data);
    setHomelessness(data.homeData.homelessness_section);
    setCommonProblems(data.homeData.about_mhg_section);

    setHeroSection(data.homeData.hero_section);
    setGeneralInformation(data.homeData.general_info_section);
    setPersonalInformation(data.homeData.personalised_plan_section);
    setHowItWorkSection(data.homeData.how_it_work_section);
  };

  return (
    <div>
      {ACCESSIBILITY_FEATURE_ENABLED ? (
        <FontResizeWidget minSize={14} maxSize={32} step={2} defaultSize={16} />
      ) : null}
      {helmetTag !== "" ? (
        <Helmet>
          {titleTag} {metaTags}
        </Helmet>
      ) : (
        <Helmet>
          <title>Home | My Housing Gateway</title>
        </Helmet>
      )}
      <div className="homepage d-flex flex-column" style={{ width: "100%" }}>
        {homepageData.isFetching ? (
          <Loader message={"Loading....."} />
        ) : homepageData.isSuccess ? (
          <Suspense>
            <div>
              <HeroSection
                title={heroSection?.title}
                page={"homepage"}
                description={heroSection?.subcopy}
                link={"link"}
                sub={"sub"}
              />
                {commonProblems ? (
                  <CommonPorblems
                    title={commonProblems?.title}
                    description={commonProblems?.subcopy}
                    suitability={commonProblems?.suitability}
                    rentingTypes={commonProblems?.renting_types}
                  />
              ) : null}
              <Chart
                dropdown={dropdownOption}
                title={howItWorkSection?.title}
                personal_Title={personalInformation?.title}
                personal_description={personalInformation?.subcopy}
                howItWorkPoints={howItWorkSection?.points}
              />
              {Array.isArray(homelessCards) && homelessCards.length > 0 ? (
                <Homelessness
                  homelessCards={homelessCards}
                  title={homelessness?.title}
                  description={homelessness?.subcopy}
                />
              ) : null}
              <div className="container start-topics">
                {topicsData.length > 0 ? (
                  <div className="card-container ">

                    <h2 className="title lightGrey mb-2">
                      {generalInformation?.title}
                    </h2>
                    <p className="text-normal lightGrey inter-font mb-2 col-12 col-md-11 ">
                      {generalInformation?.subcopy}
                    </p>
                    <ul className="d-flex justify-content-start">
                      {topicsData.map((item, idx) => {
                        const key = item.topicId || item.topicSlug || idx;
                        return (
                          <Cards
                            key={key}
                            type="topic"
                            title={item.topicTitle}
                            link={item.topicSlug}
                            id={item.topicId}
                          />
                        );
                      })}
                    </ul>
                    {/* <GetHelpSection description={"For general information, browse by topic instead"} /> */}
                  </div>
                ) : null}
                <div className="mt-4">
                  <Link className="button" to="/faq">
                    Frequently Asked Questions
                  </Link>
                </div>
              </div>
            </div>
          </Suspense>
        ) : null}
      </div>
    </div>
  );
};

export default Homepage;
